/* prefetch-intent.js - readable version. This lightweight script follows a sensible “hover/touch intent” prefetch pattern to improve perceived navigation speed for subsequent page loads */
(function(){
  const opts = {
    maxPrefetches: 5,
    linkSelector: 'a[href]:not([data-no-prefetch])', // Allow opting out
    onlyPathRegex: /\/(products|collections)\b/,
    idleTimeout: 1500,
    excludeSelectors: ['.quick-add', '.quick-view'] // Avoid Horizon's AJAX elements
  };

  // Basic support check for link element
  function supportsLink() {
    try { return !!document.createElement('link').rel; } catch { return false; }
  }

  // Respect Save-Data & very slow networks
  function shouldSkip() {
    const conn = navigator.connection || {};
    if (navigator.connection && navigator.connection.saveData) return true;
    const et = conn.effectiveType;
    return et && /2g|slow-2g/i.test(et);
  }

  // Is this an internal HTML link (ignore assets, anchors)
  function isInternalLink(href) {
    try {
      const url = new URL(href, location.href);
      // Skip Shopify admin, cart AJAX, and app proxy URLs
      if (/\/(admin|cart\/|apps\/)/.test(url.pathname)) return false;
      
      return url.hostname === location.hostname &&
             !url.hash &&
             !/\.(jpe?g|png|svg|gif|webp|pdf|css|js|woff2?|ttf)$/i.test(url.pathname);
    } catch {
      return false;
    }
  }

  let prefetchCount = 0;
  function prefetch(href) {
    if (prefetchCount >= opts.maxPrefetches) return;
    if (document.querySelector('link[rel="prefetch"][href="' + href + '"]')) return;
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    document.head.appendChild(link);
    prefetchCount++;
  }

  function schedule(fn) {
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: opts.idleTimeout });
    else setTimeout(fn, 300);
  }

  function triggerPrefetch(href) {
    schedule(() => prefetch(href));
  }

    function init() {
    if (!supportsLink() || shouldSkip()) return;
    const links = Array.from(document.querySelectorAll(opts.linkSelector))
      .filter(link => !opts.excludeSelectors.some(sel => link.matches(sel)));
    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isInternalLink(href)) return;
      if (opts.onlyPathRegex && !opts.onlyPathRegex.test(href)) return;

      let hovered = false;
      link.addEventListener('mouseover', () => {
        if (hovered) return;
        hovered = true;
        triggerPrefetch(href);
      }, { passive: true });

      link.addEventListener('touchstart', () => {
        triggerPrefetch(href);
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();